import {clsx} from 'clsx'
import {ThreeBarsIcon, XIcon} from '@primer/octicons-react'

import styles from './HeaderMenuToggle.module.css'

type HeaderMenuToggleProps = {
  isOpen: boolean
  onToggle: () => void
  ref?: React.Ref<HTMLButtonElement>
  redesign?: boolean
}

/**
 * Hamburger toggle for the mobile menu (hidden at `lg`+). The three bars morph into
 * an "X" when `isOpen` adds the `toggleClose` modifier — a self-contained port of
 * Primer Brand's `SubdomainNavBar` menu button (see the rationale in `HeaderMenuToggle.module.css`).
 */
export function HeaderMenuToggle({isOpen, onToggle, ref, redesign = false}: HeaderMenuToggleProps) {
  return (
    <button
      ref={ref}
      type="button"
      className={clsx(styles.toggle, isOpen && styles.toggleClose)}
      aria-label="Toggle navigation"
      aria-expanded={isOpen}
      onClick={onToggle}
    >
      {redesign ? (
        isOpen ? (
          <XIcon size={16} />
        ) : (
          <ThreeBarsIcon size={16} />
        )
      ) : (
        <>
          <span className={styles.toggleBar} />
          <span className={styles.toggleBar} />
          <span className={styles.toggleBar} />
        </>
      )}
    </button>
  )
}
